import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { createCustomField } from './createCustomField';
import { type CreateCustomFieldPayload } from './types';

/**
 * Custom hook for creating a custom field using mutations.
 *
 * @returns An object containing the mutation function and other properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Custom-Field/operation/create_custom_field_custom_field_post
 */
export const useMutationCreateCustomField = (options?: UseMutationOptions) => {
  return useMutation({
    mutationFn: async (customFieldData: CreateCustomFieldPayload) =>
      createCustomField(customFieldData),
    ...options,
  });
};
